// extracted by mini-css-extract-plugin
export default {"copy":"styles_copy__Dhd4g"};